
import { fontSizes, fontWeights } from "./Scales";

export const font = {

    pageTitle: {
        fontSize: fontSizes.xxl,
        fontWeight: fontWeights.semibold
    },
    tileTitle: {
        fontSize: fontSizes.xl,
        fontWeight: fontWeights.semibold
    },
    sectionTitle: {
        fontSize: fontSizes.lg,
        fontWeight: fontWeights.semibold
    },

    label: {
        fontSize: fontSizes.sm,
        fontWeight: fontWeights.medium
    },

    menu: {
        fontSize: fontSizes.sm,
        fontWeight: fontWeights.medium
    },

    tableHeader: {
        fontSize: fontSizes.sm,
        fontWeight: fontWeights.semibold
    },

    breadcrumb: {
        fontSize: fontSizes.md,
        fontWeight: fontWeights.medium
    },

    button: {
        fontSize: fontSizes.md,
        fontWeight: fontWeights.medium
    },

    dropdown: {
        fontSize: fontSizes.sm,
        fontWeight: fontWeights.medium
    },

    dialogTitle: {
        fontSize: fontSizes.md,
        fontWeight: fontWeights.semibold
    },

    bodyText: {
        fontSize: fontSizes.md,
        fontWeight: fontWeights.regular
    }

};